<template>
  <div>
    <component
      v-for="(block, index) in text"
      v-bind:is="'v-' + block.acf_fc_layout"
      v-bind="block"
      :key="'text:' + block.acf_fc_layout + ':' + index"
      :class="{ '-white': isWhite }"
    />
  </div>
</template>

<script>
import VTitle from "./text/Title.vue";
import VText from "./text/Text.vue";
import VFileLink from "./text/FileLink.vue";
import VContact from "./text/Contact.vue";
import VButtonLink from "./text/ButtonLink.vue";
import VLinkList from "./text/LinkList.vue";
import VTeamMember from "./text/TeamMember.vue";

export default {
  props: {
    isWhite: Boolean,
    text: Array,
  },
  components: {
    VTitle,
    VText,
    VFileLink,
    VContact,
    VButtonLink,
    VLinkList,
    VTeamMember,
  },
};
</script>

<style lang="scss" scoped>
.-white {
  color: #fff;
}
</style>
